import { render, staticRenderFns } from "./crimeCardData.vue?vue&type=template&id=7458b3e6"
import script from "./crimeCardData.vue?vue&type=script&lang=js"
export * from "./crimeCardData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports